import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/*
 * Un singur incident pe aplicatie (aplicatiile de business).
 *
 *   GET  /business-apps/{id}/incidents?all=1        "Open incidents" pe fisa aplicatiei, cu bifa
 *   POST /business-apps/{id}/incidents/settings     scope (app|provider), enabled (on|off|inherit), window
 *   GET  /easeedesk/tickets/{id}/app-incident       "Part of incident: ..." pe fisa tichetului
 */

export type AppIncidentTicket = {
  id: number
  subject: string
  status: string
  statusColor: string
  closed: boolean
  /** "SRV-SQL01 (Database)" */
  component: string
}

export type AppIncident = {
  id: number
  ticketId: number
  subject: string
  state: string
  openedAt: string
  closedAt: string | null
  open: boolean
  tickets: AppIncidentTicket[]
}

export type AppIncidentSetting = 'on' | 'off' | 'inherit'

export type AppIncidentsPage = {
  ready: boolean
  enabled?: boolean
  since?: string | null
  providerEnabled?: boolean
  appSetting?: AppIncidentSetting
  windowMinutes?: number
  canEdit?: boolean
  canEditProvider?: boolean
  incidents?: AppIncident[]
}

export type TicketAppIncident = {
  ready: boolean
  incident: (AppIncident & { role: 'parent' | 'child'; appId: number; appName: string }) | null
}

export function appIncidentsQuery(appId: number, all: boolean) {
  return queryOptions({
    queryKey: ['business-apps', 'incidents', 'app', appId, all],
    queryFn: () => apiGet<AppIncidentsPage>(`/business-apps/${appId}/incidents${all ? '?all=1' : ''}`),
    enabled: appId > 0,
  })
}

export function ticketAppIncidentQuery(ticketId: number) {
  return queryOptions({
    queryKey: ['business-apps', 'incidents', 'ticket', ticketId],
    queryFn: () => apiGet<TicketAppIncident>(`/easeedesk/tickets/${ticketId}/app-incident`),
    enabled: ticketId > 0,
  })
}

export function saveAppIncidentSettings(
  appId: number,
  fields: { scope: 'app' | 'provider'; enabled: AppIncidentSetting; window: number },
) {
  return apiPost<{ status: 'OK' | 'ERROR'; message?: string }>(`/business-apps/${appId}/incidents/settings`, fields)
}
